import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toastr } from 'react-redux-toastr';

import Input from '../../../bergmannsoft/components/Widgets/Forms/Input';
import InputDropdown from '../../../bergmannsoft/components/Widgets/Forms/InputDropdown';

import { ModalInstanceWrapper } from './styles';

const ModalCreateVoicebotInstance = ({
  organizations,
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [instanceData, setInstanceData] = useState({
    name: '',
    baseUrl: '',
    tokenUser: '',
    tokenPassword: '',
    crmUploadKey: '',
    organizationIds: [],
  });

  const handleInputChange = (name, value) => {
    setInstanceData({ ...instanceData, [name]: value });
  };

  const validateInstanceData = () => {
    const {
      name,
      baseUrl,
      tokenUser,
      tokenPassword,
      organizationIds,
      crmUploadKey,
    } = instanceData;

    if (!name) {
      toastr.error('Erro de validação', 'Informe o nome');
      return false;
    }
    if (!baseUrl) {
      toastr.error('Erro de validação', 'Informe a url base');
      return false;
    }
    if (!tokenUser) {
      toastr.error('Erro de validação', 'Informe o token de usuário');
      return false;
    }
    if (!tokenPassword) {
      toastr.error('Erro de validação', 'Informe o token da senha');
      return false;
    }
    if (!crmUploadKey) {
      toastr.error(
        'Erro de validação',
        'Informe a chave para upload de áudios'
      );
      return false;
    }
    if (!organizationIds?.length) {
      toastr.error('Erro de validação', 'Selecione o setor');
      return false;
    }

    return true;
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const isValidInstanceData = validateInstanceData();

    if (isValidInstanceData) {
      const formattedStringData = {};
      Object.keys(instanceData).forEach((key) => {
        const keyValue = instanceData[key];
        formattedStringData[key] =
          typeof keyValue === 'string' ? keyValue.trim() : keyValue;
      });
      onSubmit(formattedStringData);
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose}>
      <ModalInstanceWrapper>
        <Modal.Header closeButton>
          <Modal.Title className="modal-instance__title">
            Nova instância
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form onSubmit={handleSubmit} id="form-create-voicebot-instance">
            <Input
              className="modal-instance__form-group"
              label="Nome"
              value={instanceData.name}
              onChange={(value) => handleInputChange('name', value)}
            />
            <Input
              className="modal-instance__form-group"
              label="Url base"
              value={instanceData.baseUrl}
              onChange={(value) => handleInputChange('baseUrl', value)}
            />
            <Input
              className="modal-instance__form-group"
              label="Token do usuário"
              value={instanceData.tokenUser}
              onChange={(value) => handleInputChange('tokenUser', value)}
            />
            <Input
              className="modal-instance__form-group"
              label="Token da senha"
              value={instanceData.tokenPassword}
              onChange={(value) => handleInputChange('tokenPassword', value)}
            />
            <Input
              className="modal-instance__form-group"
              label="Chave para upload de áudios"
              value={instanceData.crmUploadKey}
              onChange={(value) => handleInputChange('crmUploadKey', value)}
            />
            <InputDropdown
              className="modal-instance__form-group"
              label="Setores"
              dropdownItemsList={organizations || []}
              dropdownItemsChecked={instanceData.organizationIds}
              onChange={(items) => handleInputChange('organizationIds', items)}
              useCheckbox
              styleWidth={316}
            />
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="submit"
            className="btn btn-primary"
            form="form-create-voicebot-instance"
          >
            salvar
          </button>
        </Modal.Footer>
      </ModalInstanceWrapper>
    </Modal>
  );
};

export default ModalCreateVoicebotInstance;
